<template>
  <div class="pendencies">
    <transition
      :name="effect"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Pendencies',
  data: () => ({
    effect: 'slide-fade'
  }),
  watch: {
    $route(to, from) {
      if (to.path === '/pendencies/filter') {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    }
  }
}
</script>

<style lang="scss">
.pendencies {
  height: 100%;

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter {
    transform: translateY(300px);
    opacity: 0;
  }

  .slide-fade-leave-to {
    transform: translateY(-400px);
    opacity: 0;
  }

  .leave-fade-enter-active {
    transition: all 0.3s ease;
  }

  .leave-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .leave-fade-enter {
    transform: translateY(-450px);
    opacity: 0;
  }

  .leave-fade-leave-to {
    transform: translateY(450px);
    opacity: 0;
  }
}
</style>
